import React, { useEffect, FC } from "react";
import { ITopType } from "@/types/ScmTypes";
import { Button } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { useExternalBillDetailsModel } from "./externalBillModelDetails"
import { DetailType } from "@/types/ScmEnums";
import { YHDetailNav } from "@/components/YHDetailNav";
import { useDictModel } from "@/views/base/dict/dictModel";
export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const { selectedNavId, replaceNav } = useNavModel();
    const { detailLookForm, getDetailLookOne } = useExternalBillDetailsModel()
    useEffect(() => {
        mode === DetailType.look && getDetailLookOne(id, mode)

    }, [mode, id])
    const goBack = () => {
        replaceNav(selectedNavId, "20")
    }
    const rightChildren = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const { getTreeNodeName } = useDictModel();
    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        // rightChildren,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送修人",
                fieldName: "contact",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送车电话",
                fieldName: "phone",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureName",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆牌照",
                fieldName: "licensePlate",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                fieldName: "shopName",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报修日期",
                fieldName: "createTime",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报修原因",
                fieldName: "repairReason",
                // span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeName",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "行驶里程",
                fieldName: "mileage",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "路线",
                fieldName: "route",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "是否拖车",
                fieldName: "isTransport",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修单位名称",
                fieldName: "supplierName",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "旧件确认返还",
                fieldName: "oldPartConfirm",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "情况说明",
                fieldName: "oldPartConfirmNote",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "回厂时间",
                fieldName: "backTime",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "验收人",
                fieldName: "checkUser",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "验收日期",
                fieldName: "checkTime",
                disable: true,
            }
        ]
    }
    const onChange = () => {

    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        disabled: true,
        labelAlign: "right",
        formValues: detailLookForm,
        onChange,
        boxs: [baseFormItem]
    }
    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        外修编号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{detailLookForm.code ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(getTreeNodeName(detailLookForm?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
